var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceOfFunds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1671 5.26145C11.4042 5.20036 11.6318 5.1109 11.8376 4.97854C12.1729 4.76254 12.5707 4.63672 12.9998 4.63672H13.7271V6.49417C14.2493 6.96545 14.6638 7.55308 14.9096 8.22581H15.5453C15.9467 8.22581 16.2726 8.55163 16.2726 8.95308V11.1822C16.2726 11.5836 15.9467 11.9094 15.5453 11.9094H14.5918C14.21 12.5698 13.6587 13.1196 12.9998 13.5029V14.8185C12.9998 15.22 12.674 15.5458 12.2725 15.5458H10.818C10.4166 15.5458 10.0907 15.22 10.0907 14.8185V14.0913H7.54528V14.7225C7.54528 15.124 7.21946 15.4498 6.818 15.4498H5.36346C4.962 15.4498 4.63619 15.124 4.63619 14.7225V12.9734C3.74528 12.1749 3.18164 11.0185 3.18164 9.72763C3.18164 7.80181 4.4311 6.17054 6.162 5.59163",
    fill: "#3158F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1671 5.26145C11.4042 5.20036 11.6318 5.1109 11.8376 4.97854C12.1729 4.76254 12.5707 4.63672 12.9998 4.63672H13.7271V6.49417C14.2493 6.96545 14.6638 7.55308 14.9096 8.22581H15.5453C15.9467 8.22581 16.2726 8.55163 16.2726 8.95308V11.1822C16.2726 11.5836 15.9467 11.9094 15.5453 11.9094H14.5918C14.21 12.5698 13.6587 13.1196 12.9998 13.5029V14.8185C12.9998 15.22 12.674 15.5458 12.2725 15.5458H10.818C10.4165 15.5458 10.0907 15.22 10.0907 14.8185V14.0913H7.54528V14.7225C7.54528 15.124 7.21946 15.4498 6.818 15.4498H5.36346C4.962 15.4498 4.63619 15.124 4.63619 14.7225V12.9734C3.74528 12.1749 3.18164 11.0185 3.18164 9.72763C3.18164 7.80181 4.4311 6.17054 6.162 5.59163",
    stroke: "#3158F2",
    strokeWidth: 1.45455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4372 3.20063C11.4312 4.19469 11.4312 5.80638 10.4372 6.80045C9.4431 7.79451 7.83141 7.79451 6.83735 6.80045C5.84328 5.80638 5.84328 4.19469 6.83735 3.20063C7.83141 2.20656 9.4431 2.20656 10.4372 3.20063",
    stroke: "#3158F2",
    strokeWidth: 1.45455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6607 8.9767C12.6738 8.98976 12.6738 9.01095 12.6607 9.02401C12.6477 9.03708 12.6265 9.03708 12.6134 9.02401C12.6004 9.01095 12.6004 8.98976 12.6134 8.9767C12.6265 8.96363 12.6477 8.96363 12.6607 8.9767",
    stroke: "#E8EDFE",
    strokeWidth: 1.45455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93833 7.54688C1.59723 7.74542 1.36523 8.11124 1.36523 8.53451C1.36523 9.16797 1.87869 9.68142 2.51214 9.68142H3.18342",
    stroke: "#3158F2",
    strokeWidth: 1.45455,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45508 7.54528H10.8187",
    stroke: "#E8EDFE",
    strokeWidth: 1.09091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceOfFunds);
export default __webpack_public_path__ + "static/media/source_of_funds.eb3b850c46268d416cb4995738b842cc.svg";
export { ForwardRef as ReactComponent };